module.exports = __webpack_public_path__ + "img/arrow-up-right-circle.e4fbcaca.svg";